








import Candle from "@/models/candle";
import CandleImage from "./CandleImage.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { AppLanguage } from "@/language";
import languageStore from "@/store/modules/language";

@Component({
  components: {
    CandleImage,
  },
})
export default class CandleInfo extends Vue {

  @Prop({
    default: "normal",
  })
  scale?: string;

  @Prop()
  text?: string;

  @Prop()
  candle?: Candle;

  get candleText(): string {
    let text = this.text;

    if (!text) {
      switch (languageStore.language) {
        case "es":
          text = 'Siempre con nosotros... ';
          break;
        case "en":
        default:
          text = 'Always with us...';
          break;
      }
    }

    return text;
  }
}
